export default store => {
  store.on("@init", () => ({
    earnings: {
      value: null
    }
  }));
  store.on("@change.quote", (state, data) => ({ quote: { ...state.quote, ...data } }));
};
